import { useEffect, useRef, useState } from "react";
import WrapperCard from "../../component-lib/Atoms/card/EventEHRWrapperCard";
import Heading from "../../component-lib/Atoms/heading/EventEHRHeading";
import Button from "../../component-lib/Molecules/button/Button";
import Table from "../../component-lib/Organisms/table/EventEHRTable";
import { plusIcon, searchIcon } from "../../assets";
import MenuDropdown from "../../component-lib/Molecules/menuDropdown/MenuDropdown";
import useDeviceType from "../../custom-hooks/DeviceType";
import { TEXT_CONSTANTS } from "../../utils/text-constants/textConstants";
import SearchSelectDropdown from "../../component-lib/Atoms/SearchSelectDropdown/EventEHRSearchSelectDropdown";
import SelectDropdown from "../../component-lib/Atoms/Select/Select";
import { INVENTORY_TYPE_OPTIONS } from "./requestInventoryDialog/requestInventoryConstants";
import {
  destructStatusData,
  getStatusBackground,
  getStatusDotColor,
  getStatusTextColor,
  getStockStatusBackground,
  getStockStatusDotColor,
  getStockStatusTextColor,
} from "../../utils/statusConstants";
import { getFacilityId, getLoginUserData } from "../../utils/getToken";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteFacilityInventory,
  getFacilityInventoryList,
  getInventoryById,
  getInventoryNotesGroupedByIds,
  patchAddFacilityInventory,
  postBulkTransfer,
  postInventoryNotes,
  postRequestInventory,
} from "./InventorySaga";
import {
  componentKey,
  setCloseAddNotesDialog,
  setCloseDeleteInventoryDialog,
  setCloseRequestInventoryDialog,
  setCloseSendBulkDialog,
  setGroupedNotesData,
} from "./InventorySlice";
import EventEHRConfirmationDialog from "../../component-lib/Molecules/confimation-dialog/EventEHRConfirmationDialog";
import moment from "moment";
import RequestInventoryDialog from "./requestInventoryDialog/RequestInventoryDialog";
import { useSearchParams } from "react-router-dom";
import ViewInventoryDialog from "./requestInventoryDialog/ViewInventoryDialog";
import AddInventoryNotesDialog from "./requestInventoryDialog/AddInventoryNotesDialog";
import SendBulkDialog from "./requestInventoryDialog/SendBulkDialog";

const InventoryManagement = () => {
  const [searchedValue, setSearchValue] = useState<string>("");
  const [pageNumber, setPageNumber] = useState(1);
  const [categoryType, setCategoryType] = useState("");
  // Optional stock-status pre-filter, driven by the ?status= query param
  // (e.g. dashboard "View All" on the Low Stock / Out of Stock cards).
  const [searchParams] = useSearchParams();
  const statusFilter = searchParams.get("status") || "";
  const [rowPerPage, setRowPerPage] = useState(10);
  const [name, setName] = useState<string>("");
  const typingTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [openDialogForRequestInventory, SetOpenDialogForRequestInventory] =
    useState(false);

  //VIEW DIALOG FROM INVENTORY LIST FOR FACILITY
  const [openViewInventoryListDialog, setOpenViewInventoryListDialog] =
    useState(false);
  const [defaultDataForViewInventoryList, setDefaultDataForViewInventoryList] =
    useState();

  //EDIT DIALOG FROM INVENTORY LIST FOR FACILITY
  const [defaultInventoryData, setDefaultInventoryData] = useState<any>({});

  //ADD NOTES DIALOG (LOCAL INVENTORY ADJUSTMENTS)
  const [openAddNotesDialog, setOpenAddNotesDialog] = useState(false);
  const [defaultDataForAddNotes, setDefaultDataForAddNotes] = useState<any>();

  //DELETE INVENTORY CONFIRMATION
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [inventoryToDelete, setInventoryToDelete] = useState<any>(null);

  //BULK SELECTION OF INVENTORY ROWS
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [openSendBulkDialog, setOpenSendBulkDialog] = useState(false);
  // Bumped to remount the table and clear its selection after a bulk transfer.
  const [tableResetKey, setTableResetKey] = useState(0);
  // Items + mode for the transfer dialog (shared by bulk and single "Send Inventory").
  const [transferItems, setTransferItems] = useState<any[]>([]);
  const [isSingleTransfer, setIsSingleTransfer] = useState(false);

  const deviceType = useDeviceType();
  const dispatch = useDispatch();

  const {
    inventoryData,
    inventoriesList,
    closeRequestInventoryDialog,
    closeAddNotesDialog,
    groupedNotesData,
    closeSendBulkDialog,
    closeDeleteInventoryDialog,
  } = useSelector((state: any) => state[componentKey]);

  const loginUserdata: any = getLoginUserData();
  const inventoryId =
    loginUserdata?.customAttributes?.facilityId || getFacilityId();

  // INVENTORY LIST COLUMN DATA
  const inventoryListTableColumns = [
    {
      field: "itemName",
      label: <div>Item Name</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.itemName}</p>;
      },
    },
    {
      field: "category",
      label: <div>Category</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.category}</p>;
      },
    },
    {
      field: "order",
      label: <div>Ordered Quantity</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.order}</p>;
      },
    },
    {
      field: "stockLevel",
      label: <div>Stock Level</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.stockLevel}</p>;
      },
    },
    {
      field: "reorderPoint",
      label: <div>Reorder Point</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.reorderPoint}</p>
        );
      },
    },
    {
      field: "status",
      label: <div>Status</div>,
      renderLogic: (row: any) => {
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <span
              className="font-weight-400 font-size-12px flex gap-1 items-center"
              style={{
                color: getStatusTextColor(row?.status),
                background: getStatusBackground(row?.status),
                borderRadius: "46px",
                padding: "4px 12px",
              }}
            >
              <span
                className="w-2 h-2"
                style={{
                  background: getStatusDotColor(row?.status),
                  borderRadius: "50%",
                }}
              ></span>
              {destructStatusData(row?.status)}
            </span>
          </div>
        );
      },
    },
    {
      field: "status",
      label: <div>Order Status</div>,
      renderLogic: (row: any) => {
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <span
              className="font-weight-400 font-size-12px flex gap-1 items-center"
              style={{
                color: getStatusTextColor(row?.orderStatus),
                background: getStatusBackground(row?.orderStatus),
                borderRadius: "46px",
                padding: "4px 12px",
              }}
            >
              <span
                className="w-2 h-2"
                style={{
                  background: getStatusDotColor(row?.orderStatus),
                  borderRadius: "50%",
                }}
              ></span>
              {destructStatusData(row?.orderStatus)}
            </span>
          </div>
        );
      },
    },
    {
      field: "expirationDate",
      label: <div>Expiration Date</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.expirationDate}</p>
        );
      },
    },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        const actions = [
          {
            label: "View Inventory",
            onClickCb: () => {
              setDefaultDataForViewInventoryList(row);
              dispatch(getInventoryNotesGroupedByIds({ ids: row?.id }));
              setOpenViewInventoryListDialog(true);
            },
          },
          {
            label: "Adjust Inventory",
            disabled: Number(row?.stockLevel) === 0,
            onClickCb: () => {
              setDefaultDataForAddNotes(row);
              setOpenAddNotesDialog(true);
            },
          },
          {
            label: "Send Inventory",
            disabled: Number(row?.stockLevel) === 0,
            onClickCb: () => {
              setTransferItems([row]);
              setIsSingleTransfer(true);
              setOpenSendBulkDialog(true);
            },
          },
          {
            label: "Delete Inventory",
            onClickCb: () => {
              setInventoryToDelete(row);
              setOpenDeleteDialog(true);
            },
          },
        ];
        if (
          row?.orderStatus === "Delivered" ||
          row?.orderStatus === "Cancelled"
        ) {
          actions.push({
            label: "Re-Order Inventory",
            onClickCb: () => {
              SetOpenDialogForRequestInventory(true);
              setDefaultInventoryData(row);
            },
          });
        }
        return (
          <>
            <div className="flex items-center">
              <MenuDropdown options={actions} />
            </div>
          </>
        );
      },
    },
  ];

  // INVENTORY LIST ROW DATA
  const inventoryListRowData = inventoriesList?.data?.map((data: any) => ({
    itemName: data?.inventory?.itemName || "-",
    category: data?.inventory?.type || "-",
    stockLevel: data?.currentStock || "0",
    reorderPoint: data?.threshold || "0",
    status: data?.status.split("_").join(" "),
    expirationDate: data?.expirationDate
      ? // Date-only value (midnight UTC) — render in UTC so it never shifts.
        moment.utc(data?.expirationDate).format("MM/DD/YYYY")
      : "-",
    order: data?.orderQuantity || "0",
    skuCode: data?.inventory?.skuCode || "-",
    id: data?.id || "-",
    orderStatus: data?.orderStatus || "-",
  }));

  useEffect(() => {
    getInventoriesList();
  }, [pageNumber, rowPerPage, searchedValue, categoryType, statusFilter]);

  // GET INVENTORY LIST
  const getInventoriesList = () => {
    const payload = {
      pageNumber: pageNumber,
      limit: rowPerPage,
      facilityId: inventoryId,
      name: searchedValue?.trim(),
      type: categoryType || undefined,
      status: statusFilter || undefined,
    };
    dispatch(getFacilityInventoryList(payload));
  };

  // HANDLE SEARCH CHANGE VALUE AND ADDED SOME DELAY
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPageNumber(1);

    const value = e.target.value;

    // CLEAR THE PREVIOUS TIMEOUT
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    // SET A NEW TIMEOUT TO DELAY THE CALLBACK
    typingTimeoutRef.current = setTimeout(() => {
      setSearchValue(value?.trim());
    }, 500); // ADJUST DELAY AS NEEDED
  };

  const requestInventoryHandler = (data: any) => {
    console.log("Data for Post:", data);
    try {
      const payload = {
        facilityId: inventoryId,
        itemId: data?.itemName,
        orderQuantity: Number(data?.quantity),
        threshold: Number(data?.thresholdValue),
        expirationDate: data?.expirationDate
          ? moment(data?.expirationDate)?.format("MM-DD-YYYY")
          : undefined,
        status: "Requested",
      };
      if (defaultInventoryData && defaultInventoryData?.id) {
        const apiPayload = {
          payload: {
            orderQuantity: Number(data?.quantity),
            threshold: Number(data?.thresholdValue),
            expirationDate: data?.expirationDate
              ? moment(data?.expirationDate)?.format("MM-DD-YYYY")
              : undefined,
            orderStatus: "Re-Order",
          },
          id: defaultInventoryData?.id,
        };
        dispatch(patchAddFacilityInventory(apiPayload));
      } else {
        dispatch(postRequestInventory(payload));
      }
    } catch (error) {
      console.log(error);
    }
  };

  // SAVE LOCAL INVENTORY ADJUSTMENT NOTES (Waste, Damaged, Expired, etc.)
  const addNotesHandler = (data: any) => {
    try {
      const payload = {
        id: defaultDataForAddNotes?.id, // facilityOrderInventoryId
        notes: data?.notes?.map((note: any) => ({
          type: note?.type,
          quantity: Number(note?.quantity),
          comment: note?.comment || "",
        })),
      };
      dispatch(postInventoryNotes(payload));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (closeRequestInventoryDialog) {
      dispatch(setCloseRequestInventoryDialog(false));
      SetOpenDialogForRequestInventory(false);
      getInventoriesList();
    }
  }, [closeRequestInventoryDialog]);

  useEffect(() => {
    if (closeAddNotesDialog) {
      dispatch(setCloseAddNotesDialog(false));
      setOpenAddNotesDialog(false);
      getInventoriesList();
    }
  }, [closeAddNotesDialog]);

  // BULK ACTION ON SELECTED INVENTORY ROWS
  const handleSendBulk = () => {
    setTransferItems(selectedRows);
    setIsSingleTransfer(false);
    setOpenSendBulkDialog(true);
  };

  const handleCloseSendBulk = () => {
    setOpenSendBulkDialog(false);
  };

  // TRANSFER SELECTED ROWS TO PHARMACY OR A FACILITY (per-item quantities)
  const handleBulkSend = (data: {
    target: string;
    facility: any;
    items: { id: string; quantity: number }[];
  }) => {
    const payload = {
      target: data?.target,
      facilityId:
        data?.target === "Facility" ? data?.facility?.value : undefined,
      items: data?.items,
    };
    dispatch(postBulkTransfer(payload));
  };

  useEffect(() => {
    if (closeSendBulkDialog) {
      dispatch(setCloseSendBulkDialog(false));
      setOpenSendBulkDialog(false);
      dispatch(setGroupedNotesData([]));
      // Remount the table → clears its selection → hides the "Send Bulk" button.
      setTableResetKey((k) => k + 1);
      getInventoriesList();
    }
  }, [closeSendBulkDialog]);

  // DELETE INVENTORY — confirm + refetch on success
  const handleDeleteConfirm = (action: string) => {
    if (action === "submit" && inventoryToDelete?.id) {
      dispatch(deleteFacilityInventory({ id: inventoryToDelete?.id }));
    }
    setOpenDeleteDialog(false);
    setInventoryToDelete(null);
  };

  useEffect(() => {
    if (closeDeleteInventoryDialog) {
      dispatch(setCloseDeleteInventoryDialog(false));
      getInventoriesList();
    }
  }, [closeDeleteInventoryDialog]);

  return (
    <WrapperCard
      customClasses="m-3 p-3 flex-1 min-h-0"
      customStyle={{ minWidth: deviceType !== "mobile" ? "400px" : "" }}
    >
      <div className="flex flex-col h-full min-w-0 gap-3">
        {/* Wraps below xl so the toolbar drops to its own line on tablets
            instead of widening the page. */}
        <div
          className={`flex flex-wrap gap-3 ${deviceType === "mobile" ? "flex-col items-start" : "items-center"} justify-between w-full`}
        >
          <Heading
            title={TEXT_CONSTANTS?.INVENTORY_LIST}
            customStyle={{ color: "#1D1D1D" }}
          />

          <div
            className={`flex flex-wrap items-center gap-3 w-full xl:w-auto xl:justify-end ${deviceType === "mobile" ? "justify-between" : ""}`}
          >
            {/* CATEGORY FILTER */}
            <div className="w-full sm:w-[180px]">
              <SelectDropdown
                name="categoryType"
                displayEmpty={true}
                value={categoryType}
                options={INVENTORY_TYPE_OPTIONS}
                onChangeCb={(e) => {
                  setPageNumber(1);
                  setCategoryType(e.target.value);
                }}
              />
            </div>
            {/* Width is applied via MUI sx inside the component, so a Tailwind
                class can't override it — size it through this wrapper. */}
            <div className="w-full sm:w-[300px]">
              <SearchSelectDropdown
                freeSolo={true}
                searchedValue={searchedValue}
                onSearchValueChangeCb={(e) => handleChange(e)}
                size="small"
                label="Search by item name"
                fullWidth="100%"
                startIcon={
                  <img
                    alt="search-icon"
                    src={searchIcon}
                    width={"18px"}
                    height={"18px"}
                  />
                }
              />
            </div>
            <Button
              label={
                selectedRows?.length
                  ? `Send Bulk Inventory (${selectedRows.length})`
                  : "Send Bulk Inventory"
              }
              variant="outlined"
              disabled={!selectedRows?.length}
              onClickCb={handleSendBulk}
              style={{
                paddingTop: "6px",
                paddingBottom: "6px",
                minWidth: "180px",
              }}
            />
            <Button
              startIcon={
                <img
                  src={plusIcon}
                  alt={"search"}
                  className="cursor-pointer w-[19px] h-[19px]"
                />
              }
              label="Request Inventory"
              variant="contained"
              onClickCb={() => {
                setDefaultInventoryData({});
                SetOpenDialogForRequestInventory(true);
              }}
              style={{
                paddingTop: "6px",
                paddingBottom: "6px",
                minWidth: "155px",
              }}
            ></Button>
          </div>
        </div>
        {/* min-w-0 lets this flex child shrink, so the wide table scrolls
            inside this container instead of widening the whole page. */}
        <div className="w-full min-w-0" style={{ overflow: "auto" }}>
          <Table
            key={tableResetKey}
            columns={inventoryListTableColumns}
            rows={inventoryListRowData}
            selectProps={{
              isSelectable: true,
              isSelectAll: true,
              selectIdentifier: "id",
              onSelectAll: () => {},
              onSelectRowsCb: (rows: any) => setSelectedRows(rows),
            }}
            paginationProps={{
              isPagination: true,
              page: pageNumber,
              totalPages: inventoriesList?.totalPages,
              totalCount: inventoriesList?.totalCounts,
              limit: rowPerPage,
              rowsPerPageOptions: [10, 25, 50],
              onPageChange: (page: any) => {
                setPageNumber(page);
              },
              handleChangeRowsPerPage: (rowPerPage: any) => {
                setRowPerPage(rowPerPage);
                setPageNumber(1);
              },
            }}
          />
        </div>
      </div>
      {openDialogForRequestInventory && (
        <RequestInventoryDialog
          // check={check}
          defaultInventoryData={defaultInventoryData}
          isOpen={openDialogForRequestInventory}
          dialogHeading={
            defaultInventoryData?.id
              ? "Re-Order Inventory"
              : "Request Inventory"
          }
          handleClose={() => {
            SetOpenDialogForRequestInventory(false);
          }}
          handleData={(data) => {
            requestInventoryHandler(data);
          }}
        />
      )}

      {/*OPEN VIEW INVENTORY LIST*/}
      {openViewInventoryListDialog && (
        <ViewInventoryDialog
          dialogHeading="View Inventory Details"
          handleClose={() => {
            setOpenViewInventoryListDialog(false);
            dispatch(setGroupedNotesData([]));
          }}
          defaultDataForInventoryList={defaultDataForViewInventoryList}
          groupedNotes={groupedNotesData}
          isOpen={openViewInventoryListDialog}
        />
      )}

      {/*ADD NOTES (LOCAL INVENTORY ADJUSTMENTS)*/}
      {openAddNotesDialog && (
        <AddInventoryNotesDialog
          dialogHeading="Adjust Inventory"
          isOpen={openAddNotesDialog}
          defaultDataForInventory={defaultDataForAddNotes}
          handleClose={() => setOpenAddNotesDialog(false)}
          handleData={(data) => addNotesHandler(data)}
        />
      )}

      {/*SEND BULK (TO PHARMACY OR FACILITY)*/}
      {openSendBulkDialog && (
        <SendBulkDialog
          isOpen={openSendBulkDialog}
          dialogHeading={
            isSingleTransfer ? "Send Inventory" : "Send Bulk Inventory"
          }
          selectedCount={isSingleTransfer ? 0 : transferItems?.length}
          selectedItems={transferItems}
          hideTable={isSingleTransfer}
          handleClose={handleCloseSendBulk}
          handleSend={(data) => handleBulkSend(data)}
        />
      )}

      {/*DELETE INVENTORY CONFIRMATION*/}
      <EventEHRConfirmationDialog
        open={openDeleteDialog}
        alertTitle="Delete Inventory"
        alertDescription={`Are you sure you want to delete "${inventoryToDelete?.itemName}"? This action cannot be undone.`}
        submitButtonTitle="Delete"
        cancelButtonTitle="Cancel"
        handleClose={handleDeleteConfirm}
      />
    </WrapperCard>
  );
};

export default InventoryManagement;
